module.exports = __webpack_public_path__ + "img/1701396576653-WhatsApp Image 2023-12-01 at 10.04.13.jpeg.a806e19d.webp";